import { api } from './baseApi';
export var paymentsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            // Существующие эндпоинты
            getPayments: builder.query({
                query: function () {
                    return ({
                        url: "/payment/all",
                        method: 'GET',
                    });
                },
                providesTags: ['Payments'],
            }),
            getPaymentsFiltered: builder.query({
                query: function (_a) {
                    var date = _a.date, period = _a.period, restaurantId = _a.restaurantId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, paymentMethod = _a.paymentMethod;
                    var params = new URLSearchParams();
                    if (date)
                        params.append('date', date);
                    if (period)
                        params.append('period', period);
                    if (restaurantId !== undefined)
                        params.append('restaurantId', restaurantId.toString());
                    if (dateFrom)
                        params.append('dateFrom', dateFrom);
                    if (dateTo)
                        params.append('dateTo', dateTo);
                    if (paymentMethod)
                        params.append('paymentMethod', paymentMethod);
                    return {
                        url: "/payment/aggregated?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Payments'],
            }),
            getPaymentsListByPeriod: builder.query({
                query: function (_a) {
                    var date = _a.date, period = _a.period, restaurantId = _a.restaurantId, paymentMethod = _a.paymentMethod;
                    var params = new URLSearchParams();
                    if (date)
                        params.append('date', date);
                    if (period)
                        params.append('period', period);
                    if (restaurantId != null)
                        params.append('restaurantId', String(restaurantId));
                    if (paymentMethod)
                        params.append('paymentMethod', paymentMethod);
                    return {
                        url: "/payment/list-by-period?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Payments'],
            }),
            getStatsRublesTopupsAggregated: builder.query({
                query: function (p) {
                    var params = new URLSearchParams();
                    Object.entries(p).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        if (v !== undefined && v !== null && String(v) !== '')
                            params.append(k, String(v));
                    });
                    return {
                        url: "/payment/stats/rubles-topups/aggregated?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Payments'],
            }),
            getStatsRublesTopupsList: builder.query({
                query: function (p) {
                    var params = new URLSearchParams();
                    Object.entries(p).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        if (v !== undefined && v !== null && String(v) !== '')
                            params.append(k, String(v));
                    });
                    return {
                        url: "/payment/stats/rubles-topups/list?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Payments'],
            }),
            getStatsRublesTopupsByPackage: builder.query({
                query: function (p) {
                    var params = new URLSearchParams();
                    Object.entries(p).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        if (v !== undefined && v !== null && String(v) !== '')
                            params.append(k, String(v));
                    });
                    return {
                        url: "/payment/stats/rubles-topups/by-package?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Payments'],
            }),
            getStatsCoinsSpendingAggregated: builder.query({
                query: function (p) {
                    var params = new URLSearchParams();
                    Object.entries(p).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        if (v !== undefined && v !== null && String(v) !== '')
                            params.append(k, String(v));
                    });
                    return {
                        url: "/payment/stats/coins-spending/aggregated?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Payments'],
            }),
            getStatsCoinsSpendingList: builder.query({
                query: function (p) {
                    var params = new URLSearchParams();
                    Object.entries(p).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        if (v !== undefined && v !== null && String(v) !== '')
                            params.append(k, String(v));
                    });
                    return {
                        url: "/payment/stats/coins-spending/list?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Payments'],
            }),
            // НОВЫЕ ЭНДПОИНТЫ ДЛЯ ПОЛЬЗОВАТЕЛЬСКИХ ОПЛАТ
            // 1. Получение всех оплат конкретного пользователя
            getUserPayments: builder.query({
                query: function (userId) {
                    return ({
                        url: "/payment/user/".concat(userId),
                        method: 'GET',
                    });
                },
                providesTags: function (result, error, userId) { return [{ type: 'UserPayments', id: userId }]; },
            }),
            // 2. Получение оплат пользователя с фильтрацией по дате
            getUserPaymentsFiltered: builder.query({
                query: function (_a) {
                    var userId = _a.userId, startDate = _a.startDate, endDate = _a.endDate;
                    var params = new URLSearchParams();
                    if (startDate)
                        params.append('startDate', startDate);
                    if (endDate)
                        params.append('endDate', endDate);
                    return {
                        url: "/payment/user/".concat(userId, "/filtered?").concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: function (result, error, _a) {
                    var userId = _a.userId;
                    return [{ type: 'UserPayments', id: userId }];
                },
            }),
            // 3. Получение статистики расходов пользователя
            getUserSpendingStats: builder.query({
                query: function (userId) {
                    return ({
                        url: "/payment/user-spending/".concat(userId),
                        method: 'GET',
                    });
                },
                providesTags: function (result, error, userId) { return [{ type: 'UserSpending', id: userId }]; },
            }),
            // 4. Получение баланса пользователя
            getUserBalance: builder.query({
                query: function (userId) {
                    return ({
                        url: "/payment/user-balance/".concat(userId),
                        method: 'GET',
                    });
                },
                providesTags: function (result, error, userId) { return [{ type: 'UserBalance', id: userId }]; },
            }),
            // 4.1. Месячная статистика трат приглашённых пользователей (для реферала)
            getReferralMonthlySpending: builder.query({
                query: function (_a) {
                    var referrerUserId = _a.referrerUserId, startDate = _a.startDate, endDate = _a.endDate;
                    var params = new URLSearchParams();
                    if (startDate)
                        params.append('startDate', startDate);
                    if (endDate)
                        params.append('endDate', endDate);
                    var qs = params.toString();
                    return {
                        url: "/payment/referral-monthly/".concat(referrerUserId).concat(qs ? "?".concat(qs) : ''),
                        method: 'GET',
                    };
                },
                providesTags: function (result, error, _a) {
                    var referrerUserId = _a.referrerUserId;
                    return [{ type: 'UserPayments', id: "referral-monthly-".concat(referrerUserId) }];
                },
            }),
            // 4.2. Платежи приглашённых пользователей
            getReferralInvitedPayments: builder.query({
                query: function (_a) {
                    var referrerUserId = _a.referrerUserId, startDate = _a.startDate, endDate = _a.endDate;
                    var params = new URLSearchParams();
                    if (startDate)
                        params.append('startDate', startDate);
                    if (endDate)
                        params.append('endDate', endDate);
                    var qs = params.toString();
                    return {
                        url: "/payment/referral-invited-payments/".concat(referrerUserId).concat(qs ? "?".concat(qs) : ''),
                        method: 'GET',
                    };
                },
                providesTags: function (result, error, _a) {
                    var referrerUserId = _a.referrerUserId;
                    return [{ type: 'UserPayments', id: "referral-invited-".concat(referrerUserId) }];
                },
            }),
            // 5. Создание платежа по карте
            createCardPayment: builder.mutation({
                query: function (paymentData) {
                    return ({
                        url: '/payment/byCard',
                        method: 'POST',
                        body: paymentData,
                    });
                },
                invalidatesTags: ['Payments', 'UserPayments'],
            }),
            // 6. Создание платежа через СБП
            createSbpPayment: builder.mutation({
                query: function (paymentData) {
                    return ({
                        url: '/payment/sbp',
                        method: 'POST',
                        body: paymentData,
                    });
                },
                invalidatesTags: ['Payments', 'UserPayments'],
            }),
            // 7. Оплата монетами
            payWithCoins: builder.mutation({
                query: function (paymentData) {
                    return ({
                        url: '/payment/withCoins',
                        method: 'POST',
                        body: paymentData,
                    });
                },
                invalidatesTags: ['Payments', 'UserPayments', 'UserBalance'],
            }),
            // 8. Подтверждение успешного платежа
            confirmPayment: builder.mutation({
                query: function (paymentData) {
                    return ({
                        url: '/payment/success',
                        method: 'POST',
                        body: paymentData,
                    });
                },
                invalidatesTags: ['Payments', 'UserPayments'],
            }),
        });
    },
    overrideExisting: false,
});
export var 
// Существующие
useGetPaymentsFilteredQuery = paymentsApi.useGetPaymentsFilteredQuery, useGetPaymentsQuery = paymentsApi.useGetPaymentsQuery, useGetPaymentsListByPeriodQuery = paymentsApi.useGetPaymentsListByPeriodQuery, useLazyGetPaymentsListByPeriodQuery = paymentsApi.useLazyGetPaymentsListByPeriodQuery, useGetStatsRublesTopupsAggregatedQuery = paymentsApi.useGetStatsRublesTopupsAggregatedQuery, useGetStatsRublesTopupsListQuery = paymentsApi.useGetStatsRublesTopupsListQuery, useGetStatsRublesTopupsByPackageQuery = paymentsApi.useGetStatsRublesTopupsByPackageQuery, useLazyGetStatsRublesTopupsListQuery = paymentsApi.useLazyGetStatsRublesTopupsListQuery, useGetStatsCoinsSpendingAggregatedQuery = paymentsApi.useGetStatsCoinsSpendingAggregatedQuery, useGetStatsCoinsSpendingListQuery = paymentsApi.useGetStatsCoinsSpendingListQuery, useLazyGetStatsCoinsSpendingListQuery = paymentsApi.useLazyGetStatsCoinsSpendingListQuery, 
// Новые хуки для запросов
useGetUserPaymentsQuery = paymentsApi.useGetUserPaymentsQuery, useGetUserPaymentsFilteredQuery = paymentsApi.useGetUserPaymentsFilteredQuery, useGetUserSpendingStatsQuery = paymentsApi.useGetUserSpendingStatsQuery, useGetUserBalanceQuery = paymentsApi.useGetUserBalanceQuery, useGetReferralMonthlySpendingQuery = paymentsApi.useGetReferralMonthlySpendingQuery, useGetReferralInvitedPaymentsQuery = paymentsApi.useGetReferralInvitedPaymentsQuery, 
// Новые хуки для мутаций
useCreateCardPaymentMutation = paymentsApi.useCreateCardPaymentMutation, useCreateSbpPaymentMutation = paymentsApi.useCreateSbpPaymentMutation, usePayWithCoinsMutation = paymentsApi.usePayWithCoinsMutation, useConfirmPaymentMutation = paymentsApi.useConfirmPaymentMutation;
